import cn from 'classnames';
import React, { useMemo } from 'react';
import Col from 'components/Grid/Col';
import { PlayerProvider } from 'components/Player';
import { UnitIdProvider } from 'state/unit';
import { useWidget } from 'state/widget/context';
import ThreeByOnePodcastInfo from '../ThreeByOnePodcastInfo';
import ThreeByOneWidgetPlayer from '../ThreeByOneWidgetPlayer';
import styles from './ThreeByOneUnit.module.scss';

export interface ThreeByOneUnitProps {
  className?: string;
  id: string;
  player?: React.ReactNode;
  podcastInfo?: React.ReactNode;
  wrapperClassName?: string;
}

const ThreeByOneUnit: React.FC<ThreeByOneUnitProps> = ({
  className,
  id,
  player,
  podcastInfo,
  wrapperClassName,
}) => {
  const {
    state: { units },
  } = useWidget();
  const unit = useMemo(() => (!units || !id ? undefined : units[id]), [
    id,
    units,
  ]);

  if (!unit) {
    return null;
  }

  return (
    <Col className={className}>
      <div className={cn(styles.wrapper, wrapperClassName)}>
        <UnitIdProvider unitId={id}>
          <PlayerProvider>
            {player ?? <ThreeByOneWidgetPlayer />}
            {podcastInfo ?? <ThreeByOnePodcastInfo />}
          </PlayerProvider>
        </UnitIdProvider>
      </div>
    </Col>
  );
};

export default ThreeByOneUnit;
